import { mapNotificationBadges } from "../../helpers";
import Time from "../../lib/Time/Time";
import { BeverageTranslation } from "../beers/types";
import { IApiBeerDrive, IApiPressureChamber, IPressureChamber } from "./types";

export const mapPressureChambers = (installation: any) =>
  (installation.pressureChambers || [])
    .map(
      ({
        alive,
        existsLeak,
        faulty: isFaulty = false,
        id,
        keg,
        lastMounted,
        lastUsed,
        name,
        open: isOpen,
        position,
        sensorConnected,
        taps,
        thingId
      }: IApiPressureChamber) => {
        const mappedPressureChamber: IPressureChamber = {
          bestBefore: keg?.bestBefore ? new Time(keg.bestBefore).getTime() : undefined,
          beverage: new BeverageTranslation(),
          beverageId: keg?.beverage?.id,
          existsLeak,
          dangerTags: 0,
          id,
          isBeerDrive: false,
          isFaulty,
          isOpen: alive && isOpen,
          lastMounted: new Time(lastMounted).getTime(),
          lastUsed: lastUsed ? new Time(lastUsed).getTime() : 0,
          name: name || "No Name",
          noKeg: false,
          // turn pressure chamber online if it is the only one offline due to being faulty
          offline:
            isFaulty && !alive
              ? installation?.pressureChambers.filter((p: IApiPressureChamber) => !p.alive)
                  .length !== 1
              : !alive,
          parentName: installation.outletName,
          position,
          sensorConnected,
          successTags: 0,
          tags: [],
          tapPosition: taps.map(tp => tp.position).sort(),
          thingId,
          volume: keg?.volume ? keg.volume / 1000 : 0,
          volumeLeft: keg?.volumeLeft ? keg.volumeLeft / 1000 : 0,
          warningTags: 0
        };

        return mapNotificationBadges(mappedPressureChamber, installation.outletCountry);
      }
    )
    .sort((pcA: IPressureChamber, pcB: IPressureChamber) => {
      return pcA.position < pcB.position ? -1 : 1;
    });

export const mapBeerDrives = (installation: any) =>
  (installation.beerDrives || [])
    .map(({ alive, id, name, position, tank, taps, thingId }: IApiBeerDrive) => {
      const mappedBeerDrive: IPressureChamber = {
        beverage: new BeverageTranslation(),
        beverageId: tank?.beverage?.id,
        dangerTags: 0,
        id,
        isBeerDrive: true,
        lastMounted: tank?.lastRefill ? new Time(tank.lastRefill).getTime() : 0,
        lastUsed: tank.lastDraft ? new Time(tank.lastDraft).getTime() : 0,
        name: name || "No Name",
        offline: !alive,
        parentName: installation.outletName,
        position,
        successTags: 0,
        tags: [],
        tapPosition: taps.map(tp => tp.position).sort(),
        thingId,
        volume: tank?.capacity ? tank.capacity : 0,
        volumeLeft: tank?.volumeLeft ? tank.volumeLeft / 1000 : 0,
        warningTags: 0
      };

      return mapNotificationBadges(mappedBeerDrive);
    })
    .sort((bdA: IPressureChamber, bdB: IPressureChamber) => {
      return bdA.position < bdB.position ? -1 : 1;
    });
